import { useMutation } from "@tanstack/react-query";
import { updateMetadataTag } from "../api/updateMetadataTag";
import { MetadataTagToUpdate } from "../types";
import { invalidateMetadataTagDetailsQuery } from "./useMetadataTagDetailsQuery";

type Params = {
  metadataTagId: string;
  metadataTag: MetadataTagToUpdate;
};

export const useUpdateMetadataTagQuery = () => {
  return useMutation({
    mutationFn: async ({ metadataTag, metadataTagId }: Params) => {
      return await updateMetadataTag(metadataTagId, metadataTag);
    },
    onSuccess: (_, variables) => {
      invalidateMetadataTagDetailsQuery(String(variables.metadataTagId));
    },
    onError: (e) => console.error(e),
  });
};
